import styled from "styled-components";

export const FullPageWithPaddingContainer = styled.div`
  height: 100%;
  width: 100%;
  max-height: 100%;
  padding: 0 ${({ theme }) => theme.spacing.spacing4.toString()};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing4.toString()};

  & > :first-child {
    margin-top: ${({ theme }) => theme.spacing.spacing4.toString()};
  }

  & > :last-child {
    margin-bottom: ${({ theme }) => theme.spacing.spacing4.toString()};
  }
`;
